import React, { useState } from "react";
import "./TimeInputModal.css";

const TimeInputModal = ({ isVisible, onSave, onClose, onBackdropPress, settings, heading }) => {
  const [hours, setHours] = useState("");
  const [minutes, setMinutes] = useState("");
  const [isFocusedHours, setIsFocusedHours] = useState(false);
  const [isFocusedMinutes, setIsFocusedMinutes] = useState(false);

  const handleFocusHours = () => {
    setIsFocusedHours(true);
  };

  const handleFocusMinutes = () => {
    setIsFocusedMinutes(true);
  };

  const handleBlurHours = () => {
    setIsFocusedHours(false);
  };

  const handleBlurMinutes = () => {
    setIsFocusedMinutes(false);
  };

  const handleSave = () => {
    const formattedHours =
      hours.trim() !== "" && !isNaN(parseInt(hours, 10))
        ? parseInt(hours, 10).toString()
        : "";
    const formattedMinutes =
      minutes.trim() !== "" && !isNaN(parseInt(minutes, 10))
        ? parseInt(minutes, 10).toString()
        : "";

    const hoursPart = formattedHours === "0" ? "" : formattedHours;
    const minutesPart = formattedMinutes === "0" ? "" : formattedMinutes;

    const formattedTime =
      hoursPart !== ""
        ? `${hoursPart}:${minutesPart.padStart(2, "0")}`
        : `:${minutesPart.padStart(2, "0")}`;

    const numHours = parseInt(hours);
    const numMins = parseInt(minutes);
    const hoursIntoMins = Math.floor(numHours * 60);
    const totalMins = Math.floor(hoursIntoMins + numMins);

    if (settings === true) {
      onSave(totalMins);
    } else {
      onSave(formattedTime);
    }

    onClose();
    setHours("");
    setMinutes("");
  };

  return (
    <div className={`overlay ${isVisible ? "visible" : "hidden"}`} onClick={onBackdropPress}>
      <div className="modal-view" onClick={(e) => e.stopPropagation()}>
        <h2 className="heading">{heading || "TIME ON GAME CLOCK"}</h2>

        <div className="inputRow">
          <input
            type="text"
            className="input"
            onFocus={handleFocusHours}
            onBlur={handleBlurHours}
            placeholder={isFocusedHours ? "" : "HH"}
            onChange={(e) => setHours(e.target.value)}
            value={hours}
            maxLength={2}
          />
          <span className="colon">:</span>
          <input
            type="text"
            className="input"
            onFocus={handleFocusMinutes}
            onBlur={handleBlurMinutes}
            placeholder={isFocusedMinutes ? "" : "MM"}
            onChange={(e) => setMinutes(e.target.value)}
            value={minutes}
            maxLength={2}
          />
        </div>

        <p className="smallTxt">(24 hours format)</p>

        <button className="forfeitBtn" onClick={handleSave}>Save</button>
      </div>
    </div>
  );
};

export default TimeInputModal;
